import React from 'react'

function SurveyCourse() {
  return (
    <div className="container mx-auto my-10 px-2 sm:px-4">
      <h3 className="font-black leading-2 text-gray-800 uppercase text-center">
        RECOGNISED ACADEMIC PROGRAMMES LEADING TO REGISTRATION AS A LICENSED SURVEYOR
      </h3>

      <div className="flex justify-center items-center mt-3">
        <table border="1" className="table table-striped border-t">
          <thead className=''>
            <tr>
              <th className="uppercase bg-black text-white">No.</th>
              <th className="uppercase bg-black text-white">programme</th>
              <th className="uppercase bg-black text-white">University</th>
              <th className="uppercase bg-black text-white">Entry Requirement</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="px-3">1.</td>
              <td className="">Bachelor of Science in Geospatial Engineering (Formerly Bachelor of Science in Surveying)</td>
              <td className="">University of Nairobi (UoN)</td>
              <td className='px-4 bg-gray-100 w-full lg:w-1/4' rowSpan="4">
                For all the enlisted programmes, the minimum entry requirement shall be a KCSE Mean Grade of C+, with at least a C+ in Mathematics and a C+ in Physics, or an equivalent qualification as evaluated and recognised by the Commission for University Education (CUE).
              </td>
            </tr>

            <tr>
              <td className="px-3">2.</td>
              <td className="">Bachelor of Engineering in Geospatial Engineering</td>
              <td className="">Technical University of Kenya (TUK)</td>
            </tr>

            <tr>
              <td className="px-3">3.</td>
              <td className="">Bachelor of Science in Geomatic Engineering and Geospatial Information Systems</td>
              <td className="">Dedan Kimathi University of Technology (DeKUT)</td>
            </tr>

            <tr>
              <td className="px-3">4.</td>
              <td className="">Bachelor of Science in Geomatic Engineering and Geospatial Information Systems</td>
              <td className="">Jomo Kenyatta University of Agriculture and Technology (JKUAT)</td>
            </tr>

            <tr>
              <td className="px-3">5.</td>
              <td className="">Bachelor of Philosophy in Land Surveying</td>
              <td className="">Technical University of Kenya (TUK)</td>
              <td className='px-4'>Applicants must possess a Higher National Diploma in Surveying and Mapping and have attained a minimum KCSE Mean Grade of C+, with at least a C+ in Mathematics and a C+ in Physics, or an equivalent qualification recognised by the Commission for University Education (CUE).</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className='mt-5'>
        <h4 className='font-black leading-2 text-gray-800 text-center'>RECOGNITION AND EVALUATION OF ACADEMIC PROGRAMMES</h4>

        <span className='italic font-medium'>(Section 11(b), Survey Act Cap. 299)</span>

        <p className='mt-2'>Under Section 11(b) of the Survey Act (Cap. 299), the Land Surveyors’ Board (LSB) shall evaluate suitable courses of study in land surveying and mathematics, together with relevant practical experience, to determine eligibility for examination and licensing as a Licensed Surveyor.</p>

        <p>The Board shall review such programmes periodically to ensure continued alignment with professional standards and industry needs.</p>

        <p>All universities offering, or seeking recognition of programmes leading to licensing are required to submit their curricula to the Land Surveyors’ Board (LSB) via <span className="text-blue-600 fw-bold underline">info@lsb.go.ke</span> and deliver hard copies to the LSB Secretariat in Ruaraka, Nairobi, for evaluation and approval.</p>
      </div>
    </div>
  )
}

export default SurveyCourse;